import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const SearchIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 17.06 17.06",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 17.06),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "1.5",
    children: [/*#__PURE__*/jsx("circle", {
      cx: "6.66",
      cy: "6.66",
      stroke: "none",
      r: "6.66"
    }), /*#__PURE__*/jsx("circle", {
      cx: "6.66",
      cy: "6.66",
      r: "5.91"
    }), /*#__PURE__*/jsx("path", {
      strokeLinecap: "round",
      d: "M12.96 12.96 16 16"
    })]
  });
};

export { SearchIcon };
//# sourceMappingURL=search.js.map
